import { Deserializable } from '../interfaces';

export class Empresa implements Deserializable {
  idEmpresa: number = 0;
  descripcion: string = '';

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
